module.exports = __webpack_public_path__ + "static/img/four_05.bac1479.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_05.png
// module id = RS92
// module chunks = 3